import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
import { UserFragment } from '../../graphql/fragments/UserFragment';
export var apply = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation apply {\n    apply {\n       ...UserFragment\n    }\n  }\n  ", "\n"])), UserFragment);